import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { NO_AUTH } from '../no-auth.inteceptor';

@Injectable({
  providedIn: 'root'
})
export class CPFService {

  token: string = '35E0064A-5A3B-4372-80E1-94F5818B82D8';
  baseUrl: string = `https://www.sintegraws.com.br/api/v1/execute-api.php?token=${this.token}`;

  constructor(private http: HttpClient) { }

  searchCPF(cpf: string, birthDate: string): Observable<any> {
    return this.http.get(
      this.baseUrl + `&cpf=${cpf}&data-nascimento=${birthDate}&plugin=CPF`,
      { context: new HttpContext().set(NO_AUTH, true) }
    ).pipe(timeout(30000));
  }

}

